import React from 'react';
import { Card, Col, Collapse, Form, Input, Row } from 'antd';
import { FileTextOutlined, ToolOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import type { TransportRouteDetailDto } from '../dto/transport';
import TransportFormSectionTitle from './TransportFormSectionTitle';

const { TextArea } = Input;

interface TransportVehicleNotesSectionProps {
  transport?: TransportRouteDetailDto | null;
  isEditMode: boolean;
}

const TransportVehicleNotesSection: React.FC<TransportVehicleNotesSectionProps> = ({
  transport,
  isEditMode,
}) => {
  const { t } = useTranslation(['transport']);

  return (
    <Card style={{ marginTop: 24 }} styles={{ body: { paddingTop: 8, paddingBottom: 8 } }}>
      <Collapse
        ghost
        defaultActiveKey={
          isEditMode
          && [
            transport?.licensePlate1,
            transport?.licensePlate2,
            transport?.driverName,
            transport?.driverPhone,
          ].some((value) => String(value ?? '').trim().length > 0)
            ? ['vehicle']
            : []
        }
        items={[
          {
            key: 'vehicle',
            label: <TransportFormSectionTitle icon={<ToolOutlined />} label={t('transport:sections.vehicleDriver')} />,
            children: (
              <Row gutter={[16, 16]}>
                <Col xs={24} md={12} xl={6}>
                  <Form.Item name="licensePlate1" label={t('transport:fields.licensePlate1')} style={{ marginBottom: 0 }}>
                    <Input placeholder={t('transport:placeholders.licensePlate')} />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={6}>
                  <Form.Item name="licensePlate2" label={t('transport:fields.licensePlate2')} style={{ marginBottom: 0 }}>
                    <Input placeholder={t('transport:placeholders.licensePlate')} />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={6}>
                  <Form.Item name="driverName" label={t('transport:fields.driverName')} style={{ marginBottom: 0 }}>
                    <Input placeholder={t('transport:placeholders.driverName')} />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={6}>
                  <Form.Item name="driverPhone" label={t('transport:fields.driverPhone')} style={{ marginBottom: 0 }}>
                    <Input placeholder={t('transport:placeholders.driverPhone')} />
                  </Form.Item>
                </Col>
              </Row>
            ),
          },
          {
            key: 'notes',
            label: <TransportFormSectionTitle icon={<FileTextOutlined />} label={t('transport:sections.notes')} />,
            children: (
              <Form.Item name="notes" label={t('transport:fields.notes')} style={{ marginBottom: 0 }}>
                <TextArea rows={4} placeholder={t('transport:placeholders.notes')} />
              </Form.Item>
            ),
          },
        ]}
      />
    </Card>
  );
};

export default TransportVehicleNotesSection;
